import backend, {AGENTCORE_ENGINE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getCase = (caseRn) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}`;
  return backend.get(url);
};

const queryCase = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey,
  };

  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }

  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${AGENTCORE_ENGINE_API}/case?${query}`;
  return backend.get(url);
};

const updateStatus = (caseRn, status) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/status`;
  const body = {
    status,
  };

  return backend.put(url, body);
};

export default {
  getCase,
  queryCase,
  updateStatus,
};
